// ═══════════════════════════════════════════════════════════════════════════
// PARTITA IVA DELL'AZIENDA — dopo la registrazione (ottobre 2026)
// ═══════════════════════════════════════════════════════════════════════════
// Decisione di Paolo: alla registrazione la P.IVA non si chiede (chi vuole solo provare ne
// scriverebbe una a caso, che poi resta nei PDF e blocca chi la registra davvero). La
// inserisce il titolare dall'app, una volta sola, entro GIORNI_PIVA giorni dalla creazione
// dell'azienda — o prima, se vuole invitare il primo collega. Passato il termine si può
// solo consultare finché non la inserisce. Valida formalmente, unica su Nexiora, e dopo il
// salvataggio la cambia solo il Platform Owner (Cloud Function impostaPivaOrganizzazione).
// Vale solo per le aziende nate dalla registrazione pubblica (campo pivaRichiesta): quelle
// create dal Platform Owner o esistenti da prima non sono toccate.
// Stessa regola nelle Regole Firestore (pivaInRegola).
// ═══════════════════════════════════════════════════════════════════════════
import { pivaValida, codiceFiscaleValido } from "./validazionePiva";

export const GIORNI_PIVA = 15;
const GIORNO = 86400000;

const comeData = (v) => v?.toDate ? v.toDate() : (v instanceof Date ? v : (v?.seconds ? new Date(v.seconds * 1000) : null));

/** Stato della P.IVA di un'organizzazione. */
export function statoPiva(org, adesso = new Date()) {
  const richiesta = !!org?.pivaRichiesta;
  const presente = !!String(org?.piva || "").trim();
  if (!richiesta || presente) return { richiesta, mancante: false, bloccata: false, scadenza: null, giorniRimasti: null };
  const creata = comeData(org?.createdAt) || adesso;
  const scadenza = new Date(creata.getTime() + GIORNI_PIVA * GIORNO);
  const giorniRimasti = Math.max(0, Math.ceil((scadenza - adesso) / GIORNO));
  return { richiesta, mancante: true, bloccata: adesso >= scadenza, scadenza, giorniRimasti };
}

/** Normalizza quanto scritto: toglie spazi, punti e il prefisso IT; maiuscole per il CF. */
export function normalizzaPiva(testo) {
  const t = String(testo || "").toUpperCase().replace(/[\s.\-/]/g, "").replace(/^IT(?=\d{11}$)/, "");
  return t;
}

/** Errore leggibile, oppure null se il valore è formalmente valido. */
export function erroreFormatoPiva(testo) {
  const p = normalizzaPiva(testo);
  if (!p) return "Inserisci la Partita IVA (o il Codice Fiscale per le ditte individuali)";
  if (/^\d{11}$/.test(p)) return pivaValida(p) ? null : "Partita IVA non valida: controlla di averla scritta bene";
  if (/^[A-Z0-9]{16}$/.test(p)) return codiceFiscaleValido(p) ? null : "Codice Fiscale non valido: controlla di averlo scritto bene";
  return "La Partita IVA ha 11 cifre, il Codice Fiscale 16 caratteri";
}
